import { bus } from '@/consts.js'
import RankOptions from '@/components/assemble/team/RankOptions'

export default {
  name: 'TeamMember',
  template: '#team-member-template',
  props: [
    'isYou',
    'rank',
    'rankName',
    'index',
    'count',
    'name',
    'rankOptions'
  ],
  components: { RankOptions },
  data () {
    return {
      chosen: false,
      showRanks: false
    }
  },
  computed: {
    lowercaseRank () {
      let x = this.rankOptions.findIndex(y => y.name === this.rankName)
      if (x === -1) {
        return this.rankOptions[1].name.toLowerCase()
      } else {
        return this.rankOptions[x].name.toLowerCase()
      }
    },
    romanTier () {
      if (this.rank < 1.695) {
        return 'IV'
      } else if (this.rank >= 1.695 && this.rank < 2.435) {
        return 'III'
      } else if (this.rank >= 2.435 && this.rank < 3.35) {
        return 'II'
      } else if (this.rank >= 3.35) {
        return 'I'
      }
    }
  },
  methods: {
    handleSelectRank (rankOptionsIdx) {
      this.chosen = true
      bus.$emit('changeRank', {
        memberIdx: this.index,
        rankOptionsIdx: rankOptionsIdx
      })
      if (!this.isYou) {
        bus.$emit('showInfo')
      }
      this.hideRankOptions()
    },
    showRankOptions () {
      this.showRanks = true
    },
    hideRankOptions () {
      this.showRanks = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/team/TeamMember.js